import React from 'react';
import { Section } from '../Section';
import { FadeUp } from '../FadeUp';
import { OrderBox } from '../OrderBox';
export function Order() {
  return <Section data-id="element-163" data-mp="mwznxnygf739">
      <FadeUp data-id="element-164" data-mp="mvg8fzkmh02j">
        <OrderBox data-id="element-165" data-mp="8y9ssdv73hhj" />
      </FadeUp>
    </Section>;
}